import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import useFirestore from "../../../../config/fireBaseHook";

const TpCreditTypeDropdown = ({
  value,
  onChange,
  name = "Credit_Type",
  label = "Credit Type",
  fullWidth = true,
  margin = "normal",
  required = false,
  disabled = false,
  ...otherProps
}) => {
  const { data: creditTypes, loading, error } = useFirestore("TpCreditType");

  const handleChange = (event) => {
    if (onChange) {
      // Create a synthetic event-like object to match the expected format
      const syntheticEvent = {
        target: {
          name: name,
          value: event.target.value,
        },
      };
      onChange(syntheticEvent);
    }
  };

  if (loading) {
    return (
      <FormControl fullWidth={fullWidth} margin={margin} disabled>
        <InputLabel>{label}</InputLabel>
        <Select value="" label={label} disabled {...otherProps}>
          <MenuItem value="">
            <CircularProgress size={20} />
            <span style={{ marginLeft: 8 }}>Loading...</span>
          </MenuItem>
        </Select>
      </FormControl>
    );
  }

  if (error) {
    return (
      <FormControl fullWidth={fullWidth} margin={margin} disabled>
        <InputLabel error>{label}</InputLabel>
        <Select value="" label={label} error disabled {...otherProps}>
          <MenuItem value="">
            <span style={{ color: "red" }}>Error loading options</span>
          </MenuItem>
        </Select>
      </FormControl>
    );
  }

  return (
    <FormControl
      fullWidth={fullWidth}
      margin={margin}
      required={required}
      disabled={disabled}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        value={value || ""}
        onChange={handleChange}
        label={label}
        name={name}
        {...otherProps}
      >
        <MenuItem value="">
          <em>Select {label}</em>
        </MenuItem>
        {creditTypes?.map((creditType) => (
          <MenuItem
            key={creditType.id}
            value={creditType.Credit_Type_abv || ""}
          >
            {creditType.Credit_Type_abv || "N/A"}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TpCreditTypeDropdown;
